enum ScenarioOutcome {
  Unknown,
  Pass,
  Fail
}

export default ScenarioOutcome;
